import { render, staticRenderFns } from "./bin-list.vue?vue&type=template&id=e45a173a"
import script from "./bin-list.vue?vue&type=script&lang=js"
export * from "./bin-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports